import React from "react";

import dynamic from "next/dynamic";
const NebhamPage = dynamic(() => import("./NebhamPage"), { ssr: false });

export default NebhamPage;
